import { resolveSafeInternalPath } from "utils/intendedUrl";

export function bookResultsPath(search) {
	const raw = new URLSearchParams(search).get("returnUrl");
	const decoded = raw?.replace(/lgAnd/g, "&").replace(/lgQuestionMark/g, "?").replace(/lgHyphen/g, "-");
	const safe = resolveSafeInternalPath(decoded, "/books");
	const url = new URL(safe, "https://akello.local");
	if (!["/books", "/my-library"].includes(url.pathname)) return "/books";
	url.searchParams.delete("book");
	url.searchParams.delete("auth");
	return url.pathname + url.search + url.hash;
}

export function bookDescription(value) {
	if (!value) return "";
	const doc = new DOMParser().parseFromString(String(value), "text/html");
	doc.querySelectorAll("script,style,iframe,object").forEach((node) => node.remove());
	doc.querySelectorAll("p,div,li,h1,h2,h3,br").forEach((node) => node.append(doc.createTextNode("\n\n")));
	return doc.body.textContent.replace(/[\t ]+/g, " ").replace(/\s*\n\s*/g, "\n\n").trim();
}

export function previewLink(book) {
	if (!book.preview_url) return null;
	try {
		const url = new URL(book.preview_url, window.location.origin);
		return ["https:", "http:"].includes(url.protocol) ? url.href : null;
	} catch { return null; }
}

export const publisherName = (book) => typeof book.publisher === "string" ? book.publisher : book.publisher?.name;
